export default "__VITE_ASSET__h1LR1WOI__"